exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropContent-2e5hc{display:none;width:218px;position:absolute;top:calc(100% + 24px);right:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:16px;z-index:500;border-radius:4px;border-bottom:solid 1px #e4e7ed;background-color:#fff}@media screen and (min-width: 1450px){.dropContent-2e5hc{display:-webkit-box;display:-ms-flexbox;display:flex}}.dropContainer-1CDgu{display:none;-webkit-box-flex:0;-ms-flex:none;flex:none;height:40px;width:218px;margin-bottom:0px;margin-left:auto;border-radius:4px;border:solid 1px #e4e7ed;font-size:16px;position:relative}@media screen and (min-width: 1450px){.dropContainer-1CDgu{display:-webkit-box;display:-ms-flexbox;display:flex}}.title-1BEaw{color:#001a5d}", ""]);

// exports
exports.locals = {
	"dropContent": "dropContent-2e5hc",
	"dropContainer": "dropContainer-1CDgu",
	"title": "title-1BEaw"
};